//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
//#endregion

/**
 * 도급사업관리 - 수급업체 (SUB_BASIC_01) 전용 로직
 * other 케이스에서 사용
 */

// 도급사업관리 - 수급업체 MST 인쇄 함수
export const PrintLogic1 = async (
  documentData,
  dispatch,
  setLoading,
  rowData1,
  searchRef
) => {
  if (!rowData1 || rowData1.length === 0) {
    dispatch(
      showSnackbar({
        message: '인쇄할 데이터가 없습니다.',
        type: 'warning',
      })
    );
    return null;
  }

  setLoading(true);

  try {
    const custNm =
      searchRef?.current?.custList?.find(
        (item) => item.value === searchRef?.current?.custCd
      )?.custNm || '';

    const headerData = [
      {
        custNm: custNm,
      },
    ];

    const tableData = rowData1;

    const printData = {
      FileName: 'SUB_BASIC_02',
      TableData: JSON.stringify(tableData),
      HeaderData: JSON.stringify(headerData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    return response.data; // Blob 반환
  } catch (e) {
    console.error('레포트 서버 인쇄 실패', e);
    dispatch(
      showSnackbar({
        message: e.message || '인쇄 중 오류가 발생했습니다.',
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};
